import axios from "../../../utils/axios";
import { useCallback, useEffect, useState } from "react";
import { BiLeftArrowAlt } from "react-icons/bi";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { PageType } from "../../../types/api";
import { useSiteState } from "../../../utils/useSiteState";
import FormHolder from "../../../components/Form/FormHolder";
import ContentPageEdit from "../../../components/ContentPageEdit";
import PageEditSidebar from "../../../components/Sidebars/PageEdit";
import { LoadingIcon } from "djinn-components";

const PagesEditScreen: React.FC<any> = () => {
  const navigate = useNavigate();
  const { site } = useSiteState();
  const { pageId, siteId } = useParams();

  const [page, setPage] = useState<PageType | null>(null);

  const [loadingPage, setLoadingPage] = useState(false);

  const getPage = useCallback(async () => {
    setLoadingPage(true);
    try {
      const { data } = await axios.get(`sites/${site.id}/pages/${pageId}`);
      setPage(data as PageType);
    } catch (error) {
      navigate(`/${site.id}/pages`);
    }
    setLoadingPage(false);
  }, [site.id, pageId, navigate]);

  const reloadPage = async () => {
    try {
      const { data } = await axios.get(`sites/${site.id}/pages/${pageId}`);
      setPage(data as PageType);
    } catch (error) {
      toast("Failed to reload page, please refresh page");
    }
  };

  useEffect(() => {
    getPage();
  }, [pageId, getPage]);

  if (loadingPage) {
    return (
      <div className="p-10 w-full h-full flex items-center justify-center flex-col">
        <LoadingIcon size={30} color="#6EB884" />
        <p className="text-sm mt-4 text-gray-400/80">Loading Page</p>
      </div>
    );
  }

  if (!loadingPage && !page)
    return <div className="p-10">Failed to load page...</div>;

  if (!page) return null;

  return (
    <>
      <title>{page.title}</title>
      <div className="flex items-start w-full">
        <div className="p-10 w-3/4 h-screen overflow-auto">
          <Link
            to={`/${siteId}/pages`}
            className="flex items-center text-red-600 mb-4 hover:text-red-800 cursor-pointer"
          >
            <BiLeftArrowAlt /> Pages
          </Link>
          <FormHolder>
            <ContentPageEdit
              page={page}
              reload={() => {
                reloadPage();
              }}
            />
          </FormHolder>
        </div>
        <div className="w-1/4 bg-gray-750 shadow-lg p-10 h-screen overflow-hidden sticky top-0 right-0">
          <PageEditSidebar site={site} page={page} updatePage={getPage} />
        </div>
      </div>
    </>
  );
};

export default PagesEditScreen;
